export default __webpack_public_path__ + "static/media/Push Notifications.6515fe45.svg";